module.exports = __webpack_public_path__ + "static/worlds-best-gin-8dd8b3c27bcfe26797fa9597f837dd61.jpg";